import { Box, Flex } from '@frontend/components';

import { useSortableListContext } from 'components/sortableListProvider';

import { SortableWorkflowStepsListItem } from './SortableWorkflowStepsListItem';
import { WorkflowStep } from './types';

type SortableWorkflowStepsListProps = {
  onRemoveStep: () => void;
  workSteps: WorkflowStep[];
};

export const SortableWorkflowStepsList = ({
  onRemoveStep,
  workSteps,
}: SortableWorkflowStepsListProps) => {
  const { orderedItems: workflowStepIds } = useSortableListContext();

  return (
    <Box as="ul" height={'100%'} margin={0}>
      {workflowStepIds.map((workStepId, index: number) => (
        <SortableWorkflowStepsListItem
          index={index}
          workflowStep={workSteps.find(
            (workStep) => workStep.id === workStepId,
          )}
          key={workStepId}
          onRemove={onRemoveStep}
        />
      ))}
      {workflowStepIds.length === 0 && (
        <Flex
          height={'100%'}
          as="li"
          flexDirection="column"
          justifyContent={'center'}
          padding="0.5rem"
          textAlign="center"
        >
          No Workflow Steps Assigned
        </Flex>
      )}
    </Box>
  );
};
